export default __webpack_public_path__ + "static/media/icn-medical.0870b9db.svg";